import { reduxForm } from 'redux-form';
import Component from './SuspendMerchantForm';
import { validate, initialValues } from './schema';

const SuspendMerchantForm = reduxForm({
  form: 'formSuspendMerchant',
  initialValues,
  enableReinitialize: true,
  validate,
})(Component);

export default SuspendMerchantForm;
